import { AppMode, InputMode } from 'app/features/settings/models';

export const getApplicationName = (appMode: AppMode) =>
    appMode === 'personal' ? 'personal-activity-app' : 'multi-user-activity-app';

export function isNfcAvailable(): boolean {
    return 'NDEFReader' in globalThis;
}

export const isPersonalScanMode = (appMode: AppMode | undefined, inputMode: InputMode | undefined) => {
    if (!inputMode) return false;
    const isScanMode = ['barcode', 'nfc'].includes(inputMode);
    return appMode === 'personal' && isScanMode;
};
